import React, { useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import { Item } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import RowActionsButton from '../common/RowActionsButton';

interface ItemActionsMenuProps {
  item: Item;
  onEdit: (item: Item) => void;
  onDelete: (item: Item) => void;
}

const ItemActionsMenu: React.FC<ItemActionsMenuProps> = ({ item, onEdit, onDelete }) => {
  const { t } = useLanguage();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return <>
    <Tooltip title={t('common.actions')}>
      <RowActionsButton
        data-testid={`item-actions-${item.id}`}
        aria-label={`${t('common.actions')}: ${item.name}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        onClick={event => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      />
    </Tooltip>
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
      <MenuItem onClick={() => { setAnchorEl(null); onEdit(item); }}>
        <ListItemIcon><EditOutlined fontSize="small" /></ListItemIcon><ListItemText>{t('common.edit')}</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => { setAnchorEl(null); onDelete(item); }} sx={{ color: 'error.main' }}>
        <ListItemIcon><DeleteOutline fontSize="small" color="error" /></ListItemIcon><ListItemText>{t('common.delete')}</ListItemText>
      </MenuItem>
    </Menu>
  </>;
};

export default ItemActionsMenu;
